/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1ec6d246"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1ec6d246&lang=css"

import exportComponent from "D:\\work\\xieyi\\collection-app-user-college\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__